import { useQueryClient } from '@tanstack/react-query';
import { FC, MouseEvent } from 'react';

import { ReactComponent as TrashIcon } from '@/assets/icons/trashbin.svg';
import ActionsDropdown, {
  ActionsDropdownButton,
} from '@/components/ActionsDropdown';
import { ActionsWrap, Td } from '@/components/Table';
import useAlerts from '@/hooks/useAlerts';
import { api } from '@/utils/api';

import { BlacklistRow } from './BlacklistModal';

interface Props {
  row: BlacklistRow;
}

const BlacklistTableRow: FC<Props> = ({ row }) => {
  const alerts = useAlerts();
  const queryClient = useQueryClient();

  const onDelete = async (e: MouseEvent<HTMLButtonElement>) => {
    try {
      e.stopPropagation();

      const confirm = await alerts.confirm(
        `Are you sure you want to delete this row?`,
      );

      if (!confirm) return;

      await api.delete<never, { id: number }>(
        `/v1/editorial/malicious-comment-links/${row.id}`,
      );

      await queryClient.invalidateQueries(['dq_comment_links_blacklist']);

      alerts.close();
    } catch (e) {
      alerts.error();
    }
  };

  return (
    <tr>
      <Td>{row.domain}</Td>
      <Td $actionsCol>
        <ActionsWrap>
          <ActionsDropdown zIndex={50}>
            <ActionsDropdownButton as="button" onClick={onDelete}>
              <span>
                <TrashIcon />
              </span>
              Delete
            </ActionsDropdownButton>
          </ActionsDropdown>
        </ActionsWrap>
      </Td>
    </tr>
  );
};

export default BlacklistTableRow;
